import apiSlice from "./ApiSlice";

const GroupApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllGroupData: builder.query({
      providesTags: ["group"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/group",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteGroupById: builder.mutation({
      invalidatesTags: ["group"],
      query: (id: any) => ({
        url: `/group/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addGroup: builder.mutation({
      invalidatesTags: ["group"],
      query: (body) => ({
        url: `/group/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getGroupById: builder.query({
      providesTags: ["group"],
      query: (id: string) => {
        return {
          url: `/group/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllGroup: builder.query({
      providesTags: ["group"],
      query: () => {
        return {
          url: `/group`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateGroupById: builder.mutation({
      invalidatesTags: ["group"],
      query: ({ body, id }) => ({
        url: `/group/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusGroupById: builder.mutation({
      invalidatesTags: ["group"],
      query: ({ body, id }) => ({
        url: `/group/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllGroupDataQuery,
  useDeleteGroupByIdMutation,
  useAddGroupMutation,
  useGetGroupByIdQuery,
  useUpdateGroupByIdMutation,
  useGetAllGroupQuery,
  useChangeStatusGroupByIdMutation,
} = GroupApi;
